import { render, staticRenderFns } from "./ProductDetailBoxImage.vue?vue&type=template&id=43fa0d72&"
import script from "./ProductDetailBoxImage.vue?vue&type=script&lang=js&"
export * from "./ProductDetailBoxImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports